import AppForm from '@/components/AppForm';
import AppPageTitle from '@/components/AppPageTitle';
import PATH from '@/config/paths/PATH';
import useFormSubmit from '@/hooks/useFormSubmit';
import { useMutation } from '@tanstack/react-query';
import { Col, Form, Input, Row, Space, Switch } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

function WheelCreate() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const wheelMutation = useMutation({
    mutationFn: () => {},
  });

  const handleOnSubmit = useFormSubmit(
    wheelMutation,
    (values) => ({
      ...values,
    }),
    {
      onOk: () => {
        navigate(PATH.WHEEL.ROOT, {
          replace: true,
        });
      },
    }
  );

  return (
    <Space direction="vertical" className="w-full">
      <AppPageTitle title="Create New Title" />
      <AppForm
        form={form}
        onSubmit={handleOnSubmit}
        targetPath={PATH.WHEEL.ROOT}
        buttonProps={{
          loading: wheelMutation.isPending,
          disabled: wheelMutation.isPending,
        }}
        disabled={wheelMutation.isPending}
      >
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              label="Title Name"
              name="name"
              rules={[{ required: true, message: 'Please enter title name' }]}
            >
              <Input placeholder="Enter tile name" />
            </Form.Item>
            <Form.Item
              label="Description"
              name="description"
              rules={[{ required: true, message: 'Please enter description' }]}
            >
              <Input placeholder="Enter description" />
            </Form.Item>
            <Form.Item name="showing" valuePropName="checked" label="Showing">
              <Switch title="Showing" />
            </Form.Item>
          </Col>
        </Row>
      </AppForm>
    </Space>
  );
}

export default WheelCreate;
